<!-- ─── Cell templates (referenced by column definitions) ─── -->

<ng-template #nameTpl let-contact>
  <div class="flex items-center gap-3">
    <div
      class="w-8 h-8 rounded-full flex items-center justify-center text-xs font-bold flex-shrink-0 select-none"
      [ngStyle]="getAvatarStyle(contact)"
    >
      {{ getInitials(contact) }}
    </div>
    <span class="text-sm font-medium">{{ contact.firstName }} {{ contact.lastName }}</span>
  </div>
</ng-template>

<ng-template #companyTpl let-contact>
  @if (contact.companyName) {
    <span class="inline-flex items-center px-2 py-0.5 rounded-md text-xs font-medium bg-surface-100 text-color border border-surface-300 whitespace-nowrap select-none">
      {{ contact.companyName }}
    </span>
  } @else {
    <span class="text-sm leading-5 text-muted-color select-none">—</span>
  }
</ng-template>

<ng-template #phoneTpl let-contact>
  @if (contact.phoneNumbers?.length) {
    <div class="flex items-center gap-2">
      <span class="text-sm text-muted-color">{{ primaryPhone(contact) }}</span>
      @if (contact.phoneNumbers.length > 1) {
        <span class="text-xs font-medium px-1.5 py-0.5 rounded-full bg-surface-100 text-muted-color">
          +{{ contact.phoneNumbers.length - 1 }}
        </span>
      }
    </div>
  } @else {
    <span class="text-sm leading-5 text-muted-color select-none">—</span>
  }
</ng-template>

<ng-template #operatorsTpl let-contact>
  @if (contact.operators?.length) {
    <div class="flex items-center">
      @for (user of contact.operators.slice(0, 5); track user.id) {
        <div
          class="w-7 h-7 rounded-full flex items-center justify-center text-xs font-bold border-2 border-surface-0 -ml-1.5 first:ml-0 select-none cursor-default"
          [ngStyle]="getUserAvatarStyle(user)"
          [pTooltip]="getUserDisplayName(user)"
          tooltipPosition="top"
        >
          {{ getUserInitials(user) }}
        </div>
      }
      @if (contact.operators.length > 5) {
        <div
          class="w-7 h-7 rounded-full flex items-center justify-center text-xs font-semibold border-2 border-surface-0 -ml-1.5 bg-surface-200 text-muted-color select-none"
          [pTooltip]="'+' + (contact.operators.length - 5) + ' altri'"
          tooltipPosition="top"
        >
          +{{ contact.operators.length - 5 }}
        </div>
      }
    </div>
  } @else {
    <span class="text-sm leading-5 text-muted-color select-none">—</span>
  }
</ng-template>

<ng-template #teamsTpl let-contact>
  @if (contact.teams?.length) {
    <div class="flex flex-wrap items-center gap-1">
      @for (team of contact.teams.slice(0, 1); track team.id) {
        <span
          class="inline-flex items-center px-2 py-0.5 rounded-md text-xs font-medium bg-surface-100 text-color border border-surface-300 whitespace-nowrap select-none"
          [pTooltip]="getTeamMembersTooltip(team)"
          tooltipPosition="top"
        >
          {{ team.name }}
        </span>
      }
      @if (contact.teams.length > 1) {
        <span
          class="text-xs font-medium px-1.5 py-0.5 rounded-full bg-surface-100 text-muted-color select-none"
          [pTooltip]="getExtraTeamsTooltip(contact)"
          tooltipPosition="top"
        >
          +{{ contact.teams.length - 1 }}
        </span>
      }
    </div>
  } @else {
    <span class="text-sm leading-5 text-muted-color select-none">—</span>
  }
</ng-template>

<!-- ─── Page ─── -->

<p-toast />

<div class="card relative">
  <p-tabs [(value)]="activeTab" (valueChange)="onTabChange($event)">
    <p-tablist>
      <p-tab value="contacts">Contatti</p-tab>
      <p-tab value="companies">Aziende</p-tab>
    </p-tablist>

    <p-tabpanels>

      <!-- ─── CONTACTS TAB ─── -->
      <p-tabpanel value="contacts">
        <kc-data-table
          [value]="contacts"
          [columns]="contactColumns"
          [totalRecords]="totalContacts"
          [rows]="rows"
          [enableSearch]="false"
          [enableFilterReset]="true"
          (onLazyLoad)="loadContacts($event)"
        >
          <ng-template #customCaption>
            <p-button
              icon="pi pi-plus"
              [rounded]="true"
              severity="success"
              [outlined]="true"
              pTooltip="Nuovo Contatto"
              (click)="createContact()"
            />
          </ng-template>
        </kc-data-table>

        <kc-loader [loading]="contactsLoading" />
      </p-tabpanel>

      <!-- ─── COMPANIES TAB ─── -->
      <p-tabpanel value="companies">
        <kc-loader [loading]="companiesLoading" />
        <kc-companies-table
          [companies]="companies"
          (createCompany)="createCompany()"
          (editCompany)="editCompany($event)"
          (deleteCompany)="deleteCompany($event)"
        />
      </p-tabpanel>

    </p-tabpanels>
  </p-tabs>
</div>
